function setCookie(name, value, days) {
	let expires = ""
	if (days) {
		const date = new Date()
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
		expires = "; expires=" + date.toUTCString()
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/"
}

function getCookie(name) {
	const nameEQ = name + "="
	const ca = document.cookie.split(';')
	for(let i = 0; i < ca.length; i++) {
		let c = ca[i]
		while (c.charAt(0) == ' ') c = c.substring(1, c.length)
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
	}
	return null
}

export const is_plan_on = () => {
	const plan_on = getCookie('plan_on')
	if (plan_on == 'true')
		return true
	else
		return process.env.REACT_APP_PLAN_ON == 'true'
}
export const set_plan_on = v => {
	setCookie('plan_on', v ? true : false, 365)
}

// ---------------------------------------------------------------------------
// 24h forecast version toggle (dev/secret — not advertised in the UI)
//
// V3 (unsafe_forecast_v3) is the DEFAULT for everyone. Appending a secret query
// param to ANY app URL pins the browser to a specific version and remembers the
// choice in a long-lived cookie so it sticks across sessions:
//
//   force V3 (explicit) ->  https://app.wand.com.au/?fc=v3-canary-9f2a
//   force V2 (fallback) ->  https://app.wand.com.au/?fc=v2-canary-4e7c
//   clear the override  ->  https://app.wand.com.au/?fc=off   (any other value)
//
// Clearing returns the browser to the default (V3) rather than pinning it to V2.
//
// Pinning either way also switches on the DataCard console trace, so the version
// in effect and how the NowCast row was decided are visible while inspecting. A
// browser on the default sees no console output — production users are unaffected.
//
// Change the two secrets below to keep them private. Whichever version is in
// effect, every next_24_hours request carries it (visible in the Network tab).
// ---------------------------------------------------------------------------
const FORECAST_PARAM = 'fc'                       // secret query-param key
const FORECAST_V3_SECRET = 'v3-canary-9f2a'       // <-- CHANGE ME: exact value that pins to V3
const FORECAST_V2_SECRET = 'v2-canary-4e7c'       // <-- CHANGE ME: exact value that pins to V2
const FORECAST_DEFAULT_VERSION = 'V3'             // what everyone gets with no override
const FORECAST_COOKIE = 'forecast_version'        // holds 'V2' | 'V3'; absent = default
const FORECAST_COOKIE_DAYS = 3650                 // ~10y; browsers cap real persistence at ~400 days, so we refresh it on every load

// NOTE: the legacy 'forecast_v3_on' cookie from the V2-default era is deliberately
// ignored. Reusing it would leave anyone who once ran ?fc=off pinned to V2 for a
// decade after V3 became the default.

// Reads the secret URL param (if present) and persists the choice to a cookie.
// Returns 'V2' | 'V3' when pinned, or null when on the default.
const resolve_forecast_override = () => {
	let version = getCookie(FORECAST_COOKIE)
	if (version != 'V2' && version != 'V3')
		version = null

	let param = null
	try {
		param = new URLSearchParams(window.location.search).get(FORECAST_PARAM)
	} catch (e) {
		param = null
	}

	if (param != null) {
		version = param == FORECAST_V3_SECRET ? 'V3' : param == FORECAST_V2_SECRET ? 'V2' : null
		if (version)
			setCookie(FORECAST_COOKIE, version, FORECAST_COOKIE_DAYS) // explicit pin persists
		else
			setCookie(FORECAST_COOKIE, '', -1)                        // unrecognised value clears the pin
	} else if (version)
		setCookie(FORECAST_COOKIE, version, FORECAST_COOKIE_DAYS)     // refresh expiry so it stays sticky

	return version
}

// Resolved once per page load: the URL param is consumed on the first call, and
// every later caller must see the same answer.
let _forecast_state = null
const forecast_state = () => {
	if (_forecast_state)
		return _forecast_state

	const override = resolve_forecast_override()
	_forecast_state = { version: override || FORECAST_DEFAULT_VERSION, pinned: override != null }

	if (_forecast_state.pinned) {
		const v = _forecast_state.version
		console.log(`%c ⚡ 24H FORECAST = ${v} (pinned) `, `color:#fff;background:${v == 'V3' ? '#c026d3' : '#0072B2'};padding:3px 8px;border-radius:4px;font-weight:bold;font-size:12px`)
		console.log(`[forecast] next_24_hours is requesting version: ${v} (unsafe_forecast_${v.toLowerCase()}). Default is ${FORECAST_DEFAULT_VERSION}; clear the pin with ?${FORECAST_PARAM}=off`)
	}

	return _forecast_state
}

// The forecast version this browser should request: 'V2' or 'V3'.
export const get_forecast_version = () => forecast_state().version

// True only when a secret param pinned this browser to a version. Gates the
// DataCard console trace so ordinary production users get a silent console.
export const is_forecast_pinned = () => forecast_state().pinned